import axios from "axios";
import 'core-js/features/object/entries';
var HTTPService = /** @class */ (function () {
    function HTTPService() {
    }
    HTTPService.prototype.formPost = function (uri, formData, options) {
        var data = new FormData();
        for (var _i = 0, _a = Object.entries(formData); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            data.append(key, value);
        }
        return axios.post(uri, data, options);
    };
    HTTPService.prototype.post = function (uri, data, options) {
        return axios.post(uri, data, options);
    };
    return HTTPService;
}());
export { HTTPService };
